export default {
  navbar: {
    home: "Home",
    features: "Features",
    whyUs: "Why Us",
    contactUs: "Contact Us",
    faq: "FAQ"
  },
  home: {
    transformingData: "Transforming Data",
    Management: "management",
    decision: "Decision",
    making: "Making",
    with: "with",
    cutting: "Cutting",
    edge: "Edge",
    technology: "Technology",
    para_01: "Empowering Organizations with Scalable Data Solutions for Actionable Insights",
    para_02: "i2Pulse is a robust, user-friendly platform designed to simplify data collection, management, and analysis. With advanced automation and innovative features, it transforms raw data into actionable insights for sectors like health, education, government, and nonprofits.",
    heading_01: "Core Features and Benefits of i2Pulse",
    card_heading_01: "Advanced Data Management Capabilities",
    card_heading_02: "Next-Level User Experience",
    card_heading_03: "Real-Time Analytics and Reporting",
    card_heading_04: "Seamless Integration Ecosystem",
    card_heading_05: "Security and Compliance",
    card_heading_06: "Scalability and Customization",
    card_para_01: "Reliable, scalable data management with dynamic form creation, aggregation, and disaggregation for insights.",
    card_para_02: "Intuitive UI, automated workflows, and role-based access enhance productivity and user security.",
    card_para_03: "Interactive dashboards, predictive analytics, and customizable reports for real-time, data-driven decision-making.",
    card_para_04: "Integrates effortlessly with third-party tools, supporting web, mobile, and custom API connections.",
    card_para_05: "Advanced encryption, security audits, and global compliance standards ensure data protection and accountability.",
    card_para_06: "Scalable architecture and customizable modules adapt to organizational growth and diverse workflows.",
    heading_02: "How It Works",
    para_03: "i2Pulse streamlines the entire data management lifecycle, from collection to analysis and automation, ensuring seamless integration, data quality, and actionable insights at every step.",
    dataCollection: "Data Collection",
    dataManagement: "Data Management",
    analysisAndReporting: "Analysis and Reporting",
    automation: "Automation",
    heading_03: "Ready to take your business Started with us ?",
    heading_04: "Transforming Data Management Across Industries",
    card_heading_07: "Health Sector ",
    card_heading_08: "Education",
    card_heading_09: "Government Agencies",
    card_heading_10: "Nonprofits and NGOs",
    card_para_07: "Centralizes patient data, tracks outbreaks, and monitors health outcomes with predictive models.",
    card_para_08: "Manages student data, tracks performance, and automates reporting for compliance and accreditation.",
    card_para_09: "Simplifies census operations, enhances transparency, and enables cross-agency data integration.",
    card_para_10: "Optimizes resource allocation, tracks program impact, and enables mobile data collection.",
    card_07: {
      list_01: { title: "Centralized Patient Records", description: "Streamline patient data management for quick access and better decision-making." },
      list_02: { title: "Disease Outbreak Monitoring", description: "Monitor and analyze outbreaks using real-time data and geospatial mapping." },
      list_03: { title: "Health Outcome Monitoring", description: "Use predictive models to assess and improve health outcomes efficiently." }
    },
    card_08: {
      list_01: { title: "Student & Teacher Data Management", description: "Efficiently manage and track student progress and teacher performance." },
      list_02: { title: "Performance Tracking", description: "Identify trends and areas for improvement with data-driven insights." },
      list_03: { title: "Automated Reporting", description: "Streamline accreditation and regulatory compliance through automated, customizable reports." }
    },
    card_09: {
      list_01: { title: "Census Operations Simplified", description: "Facilitate large-scale data collection and analysis for accurate census reporting." },
      list_02: { title: "Monitor Public Service Programs", description: "Track and optimize public service initiatives for better outcomes." },
      list_03: { title: "Cross-Agency Data Integration", description: "Enable seamless data integration and collaboration across multiple government agencies." }
    },
    card_10: {
      list_01: { title: "Resource Allocation Optimization", description: "Allocate resources effectively based on real-time data and insights." },
      list_02: { title: "Program Impact Tracking", description: "Monitor and measure the success of programs and initiatives to ensure accountability." },
      list_03: { title: "Mobile Data Collection", description: "Use mobile-friendly tools for data gathering in remote areas or places with limited internet connectivity." }
    }
  },
  features: {
    heading_01: "Core Features and Benefits of i2Pulse",
    banner_title_01: "Advanced Data Management",
    banner_title_02: "Next-Level User Experience",
    banner_title_03: "Real-Time Analytics and Reporting",
    banner_title_04: "Seamless Integration Ecosystem",
    banner_title_05: "Security and Compliance",
    banner_title_06: "Scalability and Customization",
    banner_01: {
      list_01: "Built on the latest, proven technologies for optimal reliability and scalability with large datasets.",
      list_02: "Supports multi-level data aggregation and disaggregation for granular, actionable insights.",
      list_03: "Dynamic form creation for customized, efficient data collection tailored to your needs."
    },
    banner_02: {
      list_01: "Intuitive and Responsive UI: Designed for ease of use, ensuring effortless navigation.",
      list_02: "Automation for Productivity: Streamlines repetitive tasks such as data imports, validations, and reporting through automated workflows.",
      list_03: "Role-Based Access Control: Customizes user experiences based on roles, ensuring secure access and permissions."
    },
    banner_03: {
      list_01: "Interactive Dashboards: Visualize data with real-time charts, graphs, and heatmaps for immediate insights.",
      list_02: "Predictive Analytics: Leverage machine learning models to predict trends and gain forward-looking insights.",
      list_03: "Customizable Reports: Generate automated, on-demand, or scheduled reports tailored to meet specific stakeholder needs."
    },
    banner_04: {
      list_01: "Integrates seamlessly with third-party tools, including GIS systems, IoT devices, and CRMs.",
      list_02: "Compatible with both web and mobile platforms for continuous data access and management, anywhere.",
      list_03: "Includes API endpoints for custom integrations, ensuring smooth connectivity with existing IT systems."
    },
    banner_05: {
      list_01: "Implements advanced encryption for secure data storage and transfer, both at rest and in transit.",
      list_02: "Regular security audits and full compliance with global data protection standards (e.g., GDPR).",
      list_03: "Audit trails and activity logs to ensure transparency, accountability, and data integrity."
    },
    banner_06: {
      list_01: "Designed to scale with your organization's growth, from small teams to large enterprises.",
      list_02: "Fully customizable modules to fit unique workflows and business requirements.",
      list_03: "Scalable architecture that supports thousands of concurrent users and large datasets without compromising performance."
    }
  },
  whyUs: {
    heading_01: "Why i2Pulse?",
    heading_02: "Why",
    heading_03: "i2Pulse?",
    subHeading_01: "Unique Selling Points That Drive Success",
    card_heading_01: "End-to-End Solution",
    card_heading_02: "Innovation Simplicity",
    card_heading_03: "Global Accessibility",
    card_heading_04: "Seamless Scalability",
    card_heading_05: "Data Security",
    card_heading_06: "Tailored to Your Needs",
    card_para_01: "i2Pulse is an all-in-one platform that simplifies data management—from collection to decision-making. It streamlines workflows, boosts efficiency, and replaces the need for multiple tools with a single, integrated solution.",
    card_para_02: "i2Pulse blends powerful automation with a user-friendly design to simplify complex tasks. By reducing manual work, it enhances productivity and helps users focus on what matters most.",
    card_para_03: "i2Pulse offers reliable access to data anytime, anywhere. With multi-language support and offline functionality, you can work seamlessly—even in remote or low-connectivity areas.",
    card_para_04: "As your business evolves, so does i2pulse. Whether you’re a startup or a global leader, our platform grows with you—delivering consistent performance and flexibility at any stage. i2pulse effortlessly adapts to your expanding needs, ensuring your operations remain smooth and efficient no matter the scale.",
    card_para_05: "With i2pulse, your data is in safe hands. We prioritize top-tier security, implementing cutting-edge encryption, and robust compliance protocols, including GDPR and beyond. Whether you're handling sensitive information or large datasets, rest easy knowing that your data is protected by industry-leading security standards.",
    card_para_06: "i2pulse isn't a one-size-fits-all solution—it’s designed to be customized for your unique business. From personalized dashboards to flexible workflows, our platform gives you the tools to create a solution that fits your exact needs. Empower your team with tailored solutions that drive results, not limitations."
  },
  contactUs: {
    heading_01: "Send an email to",
    heading_02: "Leave us a message",
    or: "Or",
    name: "Name",
    email: "Email",
    contactNumber: "Contact number",
    message: "Message",
    cancel: "Cancel",
    submit: "Submit"
  },
  readMore: {
    heading_01: "How it works",
    subHeading_01: "Streamlining Data Management from Collection to Decision-Making",
    banner_title_01: "Data Collection",
    banner_title_02: "Data Management",
    banner_title_03: "Analysis and Reporting",
    banner_title_04: "Automation",
    banner_01: {
      list_01: "Customizable Forms: Design forms specific to your data collection needs.",
      list_02: "Automated Imports: Import data from external sources automatically, reducing manual effort.",
      list_03: "Real-Time Data Capture: Collect data in real time from various sources for immediate use.",
      list_04: "Integration with IoT & External Databases: Easily integrate with IoT devices and external databases for a comprehensive data ecosystem.",
      list_05: "Manual Data Entry: Support for manual data entry for areas where automation isn't possible."
    },
    banner_02: {
      list_01: "Advanced Storage: Store large volumes of structured and unstructured data securely and efficiently.",
      list_02: "Organized Data Processing: Use advanced technologies for processing data to ensure consistency and accuracy.",
      list_03: "Error Validation: Built-in checks to identify and correct errors, ensuring data integrity.",
      list_04: "Duplicate Detection: Prevent data duplication by automatically detecting and flagging duplicates in the system."
    },
    banner_03: {
      list_01: "Interactive Dashboards: Visualize data through charts, graphs, and heatmaps for a clear, real-time overview.",
      list_02: "KPIs: Track key performance indicators for a focused analysis of your organization’s objectives.",
      list_03: "Real-Time Data Capture: Collect data in real time from various sources for immediate use.",
      list_04: "Custom Reports: Generate automated, on-demand, or scheduled reports tailored to specific stakeholder needs."
    },
    banner_04: {
      list_01: "Predefined Workflow Rules: Create automated workflows for repetitive tasks like data imports, updates, and validations.",
      list_02: "Automated Alerts: Set up alerts for critical changes in data or system status.",
      list_03: "Routine Operations Automation: Perform everyday operations like reporting and updates automatically, reducing manual work.",
      list_04: "Reduced Human Intervention: Minimize human errors and ensure consistent, timely execution of tasks."
    }
  },
  common: {
    and: "and",
    registerNow: "Register Now",
    knowMore: "Know More",
    learnMore: "Learn More",
    requestDemo: "Request a Demo",
    login:"Login"
  },
  coreCapabilities: {
    tagline: "Core Capabilities",
    heading: "Configure i2Pulse to fit your workflows",
    dynamicFormsTitle: "Dynamic Forms",
    dynamicFormsDesc: "Capture and validate data effortlessly.",
    liveDashTitle: "Live Dashboards",
    liveDashDesc: "Visualize operations in real-time.",
    roleAccessTitle: "Role-Based Access",
    roleAccessDesc: "Keep your digital environment secure.",
    workflowTitle: "Workflow Automation",
    workflowDesc: "Eliminate manual reporting and tasks."
  },
  performanceBanner: {
    title: "Program Performance at a Glance",
    subtitle: "Real-time operational visibility driving real results.",
    stats: {
      completeness: "Data Completeness",
      records: "Records Processed",
      locations: "Active Locations",
      reports: "Automated Reports"
    }
  },
  everyRole: {
    headingPart1: "Built for",
    headingPart2: "Every Role",
    subheading: "Connect your entire workflow from the field to the boardroom:",
    roles: {
      fieldUsers: {
        title: "Field Users",
        desc: "Enter data effortlessly through simple digital forms."
      },
      dataManagers: {
        title: "Data Managers",
        desc: "Validate submissions instantly for total accuracy."
      },
      analysts: {
        title: "Analysts",
        desc: "Explore trends and uncover deep, actionable insights."
      },
      leaders: {
        title: "Leaders",
        desc: "Make confident decisions with real-time performance dashboards."
      }
    }
  },
  versatilePlatform: {
    tagline: "Versatile Across Industries",
    headingPart1: "A flexible platform ready to support",
    headingPart2: "your specific mission:",
    categories: {
      mAndE: "Monitoring & Evaluation (M&E)",
      publicHealth: "Public Health Surveillance",
      education: "Education Monitoring",
      compliance: "Compliance & Service Delivery",
      nonprofit: "Nonprofit Impact Measurement",
      enterprise: "Enterprise Performance"
    }
  },
  howItWorks: {
    badge: "How it works",
    heading: {
      line1: "Smarter data.",
      line2: "Smoother workflows.",
      highlight: "Better outcomes."
    },
    description: "i2Pulse streamlines the entire data management lifecycle, from collection to analysis and automation, ensuring seamless integration, data quality, and actionable insights at every step.",
    reliability: {
      line1: "Built for reliability.",
      line2: "Designed for impact.",
      line3: "Seamless data. Smarter decisions."
    },
    features: {
      collection: {
        title: "Data Collection",
        desc: "Capture accurate data from any source, online or offline, in real time."
      },
      management: {
        title: "Data Management",
        desc: "Organize, validate, and secure your data with powerful management tools."
      },
      analysis: {
        title: "Analysis and Reporting",
        desc: "Turn data into insights with interactive dashboards and custom reports."
      },
      automation: {
        title: "Automation",
        desc: "Automate workflows and alerts to save time, reduce errors, and boost productivity."
      }
    },
    cta: "Know More"
  }, "sectorWiseExamples": {
    "badge": "SECTOR-SPECIFIC EXAMPLES",
    "headingPart1": "What you can build with",
    "headingPart2": "i2Pulse",
    "description": "See exactly how i2Pulse can be configured to match the unique language, metrics, and workflows of your specific domain.",
    "cards": {
      "health": {
        "title": "Health Information Management",
        "description": "Configure disease surveillance, immunization tracking, and facility reporting forms.",
        "points": [
          "Monitor outbreak alerts & regional gaps",
          "Track immunization coverage in real time",
          "Unified dashboard for timely decision-making"
        ]
      },
      "education": {
        "title": "Education Management",
        "description": "Build comprehensive school profiles, track student enrollment, and monitor daily attendance.",
        "points": [
          "Compare district performance easily",
          "Identify dropout risks early",
          "Optimize resource allocation"
        ]
      },
      "government": {
        "title": "Government Performance Monitoring",
        "description": "Track citizen services, municipal performance, and social protection programs.",
        "points": [
          "Measure service delivery & satisfaction",
          "Monitor grievance resolution",
          "Ensure transparency with public dashboards"
        ]
      },
      "ngo": {
        "title": "NGO Program Impact",
        "description": "Convert field activities into credible evidence and demonstrate real impact.",
        "points": [
          "Track beneficiary reach & outcomes",
          "Measure partner performance",
          "Generate donor-ready impact reports"
        ]
      },
      "enterprise": {
        "title": "Enterprise Operations",
        "description": "Connect distributed teams with internal KPI dashboards.",
        "points": [
          "Monitor branch performance",
          "Track compliance & quality",
          "Optimize resource utilization"
        ]
      },
      "research": {
        "title": "Research & Survey Programs",
        "description": "Streamline data collection with custom surveys and real-time insights.",
        "points": [
          "Manage field teams efficiently",
          "Validate data in real time",
          "Export clean datasets for analysis"
        ]
      }
    },
    "impactBanner": {
      "badge": "Built to deliver impact"
    },
    "impactFeatures": {
      "domain": {
        "title": "Domain-Specific",
        "description": "Configure to your language & workflows"
      },
      "flexible": {
        "title": "Flexible & Scalable",
        "description": "Adapt as your programs and operations evolve"
      },
      "evidence": {
        "title": "Evidence-Driven",
        "description": "Make better decisions with trusted data"
      },
      "secure": {
        "title": "Secure & Compliant",
        "description": "Built with enterprise-grade security & governance"
      },
      "impact": {
        "title": "Built for Impact",
        "description": "Focus on outcomes that matter most"
      }
    }
  },
  "industrySolutions": {
    "badge": "INDUSTRY SOLUTIONS",
    "heading": {
      "part1": "Transforming Data Management",
      "part2": "Across",
      "highlight": "Sectors"
    },
    "description": "i2Pulse adapts to the unique workflows of industries where accurate data, timely reporting, and evidence-based decisions are critical to success.",
    "sectors": {
      "healthcare": {
        "title": "Healthcare & Public Health",
        "description": "Centralize facility data, track disease surveillance, and optimize resource allocation to improve patient outcomes.",
        "features": {
          "f1": { "label": "Track Outcomes", "text": "Monitor disease outbreaks, service delivery, and health indicators." },
          "f2": { "label": "Map Performance", "text": "Visualize metrics by region, district, or individual facility." },
          "f3": { "label": "Drive Strategy", "text": "Support proactive public health planning and resource prioritization." }
        }
      },
      "education": {
        "title": "Education Systems",
        "description": "Manage student, teacher, and institutional data in one centralized hub to drive better academic outcomes.",
        "features": {
          "f1": { "label": "Monitor Metrics", "text": "Track enrollment, attendance, and learning performance." },
          "f2": { "label": "Automate Compliance", "text": "Streamline accreditation and institutional reporting." },
          "f3": { "label": "Plan the Future", "text": "Power evidence-based education planning for districts and universities." }
        }
      },
      "government": {
        "title": "Government Agencies",
        "description": "Improve transparency, service delivery, and policy planning with secure, cross-agency data coordination.",
        "features": {
          "f1": { "label": "Simplify Collection", "text": "Streamline census operations and administrative data gathering." },
          "f2": { "label": "Break Down Silos", "text": "Enable seamless data sharing and reporting across agencies." },
          "f3": { "label": "Empower Leaders", "text": "Fuel executive dashboards to make confident, policy-level decisions." }
        }
      },
      "ngo": {
        "title": "Nonprofits & NGOs",
        "description": "Streamline Monitoring and Evaluation (M&E) to track beneficiaries, measure real-world impact, and report to donors confidently.",
        "features": {
          "f1": { "label": "Empower the Field", "text": "Collect data anywhere with mobile and offline-ready forms." },
          "f2": { "label": "Measure Impact", "text": "Track program activities, outputs, and long-term outcomes." },
          "f3": { "label": "Engage Donors", "text": "Generate transparent, evidence-based reports to secure funding." }
        }
      }
    },
    "featuresBanner": {
      "f1": {
        "title": "One Unified Platform",
        "description": "All your data. All your teams. One trusted source."
      },
      "f2": {
        "title": "Real-Time. Everywhere.",
        "description": "Live data and insights when and where you need them."
      },
      "f3": {
        "title": "Secure by Design",
        "description": "Enterprise-grade security to protect what matters most."
      },
      "f4": {
        "title": "Data. Decisions. Impact.",
        "description": "Turn information into action and create lasting impact."
      }
    }
  },
  "governanceAndSecurity": {
    "badge": "GOVERNANCE & SECURITY",
    "heading": {
      "part1": "Designed for Trust, Accountability,",
      "part2": "and",
      "highlight": "Controlled Access"
    },
    "description": "i2Pulse is a secure operating environment built to protect sensitive, regulated, and mission-critical data—from patient records to student and beneficiary information.",
    "features": {
      "roles": {
        "title": "Role-Based Permissions",
        "description": "Define exact access levels for administrators, data entry teams, approvers, and external partners."
      },
      "audit": {
        "title": "Comprehensive Audit Trails",
        "description": "Ensure total accountability by tracking every submission, edit, approval, and data export."
      },
      "access": {
        "title": "Granular Access Control",
        "description": "Restrict data visibility strictly by geography, department, facility, or specific project."
      },
      "compliance": {
        "title": "Global Compliance Readiness",
        "description": "Secure your operations with robust encryption and GDPR-aligned data protection practices."
      }
    },
    "banner": {
      "heading": "Security Built Into Every Layer",
      "items": {
        "encryption": {
          "title": "Encryption",
          "description": "End-to-end data encryption protection."
        },
        "backups": {
          "title": "Secure Backups",
          "description": "Automated backups for data recovery."
        },
        "auth": {
          "title": "Authentication",
          "description": "MFA and strong password protection."
        },
        "monitoring": {
          "title": "Monitoring",
          "description": "24/7 threat detection and monitoring."
        },
        "retention": {
          "title": "Data Retention",
          "description": "Manage retention and secure disposal."
        }
      }
    },
    "footerText": "Your data. Your trust. Our responsibility."
  },
  "integrationArchitecture": {
    "badge": "INTEGRATION ARCHITECTURE",
    "headingPart1": "Connect i2Pulse with Your Existing",
    "headingPart2": "Digital Ecosystem",
    "description": "A powerful data platform shouldn't operate in a silo. i2Pulse integrates seamlessly with your data ecosystem.",
    "diagram": {
      "dataSources": "Data Sources",
      "integrations": "Integrations",
      "enterpriseSystems": "Enterprise Systems",
      "outputs": "Outputs & Destinations"
    },
    "featureList": {
      "openApi": { "title": "Open API Connectivity", "description": "Enable secure, real-time system-to-system communication with robust API endpoints." },
      "ecosystem": { "title": "Ecosystem Compatibility", "description": "Connect effortlessly with CRMs, IoT devices, mobile applications, and enterprise reporting portals." },
      "gis": { "title": "GIS & Mapping Support", "description": "Integrate with Geographic Information Systems (GIS) for advanced location-based monitoring and planning." },
      "dataImports": { "title": "Seamless Data Imports", "description": "Easily pull in historical records or periodic data from legacy databases and spreadsheets." },
      "customConnectors": { "title": "Custom Connectors", "description": "Receive tailored integration support to connect unique workflows, financial platforms, and proprietary systems." }
    },
    "dataSources": {
      "webMobile": "Web & Mobile\nForms",
      "iot": "IoT Devices",
      "fieldApps": "Field\nApplications",
      "spreadsheets": "Spreadsheets",
      "legacyDb": "Legacy\nDatabases"
    },
    "integrations": {
      "restApi": "RESTful APIs",
      "webhooks": "Webhooks",
      "sftp": "SFTP / FTP",
      "secureConnectors": "Secure Connectors"
    },
    "enterprise": {
      "crm": "CRM Systems",
      "erp": "ERP / Financial Systems",
      "hr": "HR / Payroll Systems",
      "documentManagement": "Document Management"
    },
    "outputs": {
      "dashboards": "Dashboards &\nReports",
      "gisMaps": "GIS & Maps",
      "emailSms": "Email & SMS\nNotifications",
      "dataWarehouses": "Data Warehouses",
      "thirdParty": "Third-Party\nApplications"
    },
    "highlights": {
      "secureByDesign": { "title": "Secure by Design", "description": "End-to-end encryption, token-based authentication, and role-based access ensure your data stays protected." },
      "realTimeSync": { "title": "Real-Time Sync", "description": "Keep data consistent across systems with real-time or scheduled synchronization." },
      "scalable": { "title": "Scalable & Future-Ready", "description": "Built on modern, cloud-native architecture that scales with your growing needs." },
      "reliable": { "title": "Reliable & Resilient", "description": "High availability, error handling, and retry mechanisms ensure uninterrupted operations." },
      "developerFriendly": { "title": "Developer Friendly", "description": "Comprehensive API documentation, sandbox environment, and SDKs for faster integration." }
    }
  },
  "trustedBySectors": {
    "headingPart1": "Trusted by organizations across",
    "headingPart2": "sectors globally",
    "sectors": {
      "health": "Health",
      "education": "Education",
      "government": "Government",
      "ngos": "NGOs",
      "enterprise": "Enterprise",
      "research": "Research"
    }
  },
  "faq": {
    "badge": "FREQUENTLY ASKED QUESTIONS",
    "headingPart1": "Common Questions",
    "headingPart2": "About",
    "headingHighlight": "i2Pulse",
    "description": "Clear answers to help you understand how i2Pulse works and how it can drive impact for your organization.",
    "items": {
      "q1": {
        "question": "Can i2Pulse replace spreadsheet-based reporting?",
        "answer": "Yes. We replace manual spreadsheets with structured digital forms, automated workflows, and live dashboards, giving your team a single, reliable source of truth."
      },
      "q2": {
        "question": "Can the platform be customized for our sector?",
        "answer": "Absolutely. i2Pulse is highly configurable for healthcare, education, government, NGOs, and enterprise operations, adapting to your specific workflows and terminology."
      },
      "q3": {
        "question": "Does i2Pulse support different user permissions?",
        "answer": "Yes. Granular role-based access allows you to control exactly who can view, edit, approve, or export data based on their specific job function or geographic location."
      },
      "q4": {
        "question": "Can i2Pulse work with our existing systems?",
        "answer": "Yes. Our open APIs and custom connectors integrate seamlessly with your current CRMs, GIS tools, legacy databases, and enterprise platforms."
      },
      "q5": {
        "question": "Is i2Pulse suitable for remote or field teams?",
        "answer": "Yes. The platform features mobile-friendly and offline-ready workflows, ensuring your field teams can capture critical data anywhere, even in low-connectivity environments."
      },
      "q6": {
        "question": "How does i2Pulse support decision-making?",
        "answer": "We connect secure data collection directly to live dashboards, automated reports, and alerts. This empowers your leadership to identify risks, allocate resources, and act on trusted insights instantly."
      }
    },
    "support": {
      "heading": "Still have questions?",
      "description": "Our team is here to help you explore how i2Pulse can transform your data into actionable impact.",
      "contactBtn": "Contact Us",
      "demoBtn": "Schedule a Demo"
    }
  },
  "dataLifecycle": {
    "badge": "How it works",
    "headingPart1": "The Complete",
    "headingHighlight": "Data Lifecycle",
    "description": "Connect every step of your data's journey — from the first point of capture in the field to the final executive decision."
  },
  "processSteps": {
    "steps": {
      "step1": {
        "title": "Data Collection",
        "paragraphs": [
          "Build dynamic, logic-driven forms for routine reporting, field monitoring, or compliance.",
          "Capture exactly what you need with required fields, conditional logic, and attachments."
        ]
      },
      "step2": {
        "title": "Data Validation",
        "paragraphs": [
          "Catch errors before they hit your reports.",
          "Automated rules instantly flag missing values, duplicates, and out-of-range entries to ensure total accuracy."
        ]
      },
      "step3": {
        "title": "Data Management",
        "paragraphs": [
          "Organize your information securely.",
          "Sort by program, location, or user role to power both granular operational analysis and high-level executive views."
        ]
      },
      "step4": {
        "title": "Analysis & Reporting",
        "paragraphs": [
          "Transform raw numbers into visual insights.",
          "Generate live dashboards, maps, and scorecards, or schedule automated reports tailored to specific stakeholders."
        ]
      },
      "step5": {
        "title": "Actionable Decisions",
        "paragraphs": [
          "Turn trusted data into real-world impact.",
          "Identify risks, allocate resources, and respond to changing operational needs with absolute confidence."
        ]
      }
    },
    "panels": {
      "validation": {
        "summaryTitle": "Validation Summary",
        "valid": "Valid",
        "warnings": "Warnings",
        "errors": "Errors",
        "issuesTitle": "Issues Found",
        "issues": {
          "item1": "Missing value in 'Age'",
          "item2": "Duplicate entry found",
          "item3": "Out of range: 'Score'"
        }
      },
      "management": {
        "title": "Data Management",
        "records": "{{count}} Records",
        "dropdowns": {
          "program": "Program",
          "allPrograms": "All Programs",
          "location": "Location",
          "allLocations": "All Locations",
          "role": "User Role",
          "allRoles": "All Roles"
        },
        "programs": {
          "nutrition": "Nutrition Program",
          "health": "Health Program",
          "wash": "WASH Program",
          "education": "Education Program"
        }
      },
      "analysis": {
        "overviewTitle": "Performance Overview",
        "trendTitle": "Trend Over Time",
        "mapTitle": "Map View",
        "metrics": {
          "totalRecords": "Total Records",
          "coverage": "Coverage",
          "locations": "Locations"
        }
      },
      "decision": {
        "title": "Decision Center",
        "viewBtn": "View",
        "items": {
          "risk": {
            "title": "High Risk Locations",
            "sub": "5 Locations"
          },
          "resources": {
            "title": "Resource Allocation",
            "sub": "Optimized"
          },
          "alerts": {
            "title": "Alerts & Notifications",
            "sub": "3 New Alerts"
          }
        }
      }
    }
  },
  footer: {
    availableOn: "Available on",
    contactEnquiry: "Contact",
    navigate: "Navigate",
    usefullLinks: "Useful links",
    footer_para: "Have questions or need help? Contact us for a demo or more information.",
    description: "A secure, scalable, and configurable data intelligence platform for organizations that need reliable data, real-time insight, and better decisions.",
    allRightsReserved: "All rights reserved.",
    playStore: "Play store",
    appStore: "App store",
    home: "Home",
    features: "Features",
    whyUs: "Why Us",
    contactUs: "Contact Us",
    register: "Register",
    login: " Login",
    platform: "PLATFORM",
    solutions: "SOLUTIONS",
    getStarted: "GET STARTED",
    letsBuild1: "Let's build",
    letsBuild2: "smarter together.",
    requestDemoBtn: "Request a Demo",
    stayConnected: "Stay Connected",
    links: {
      Overview: "Overview",
      Features: "Features",
      Services: "Services",
      Health: "Health",
      Education: "Education",
      Government: "Government",
      NGOs: "NGOs",
      RegisterNow: "Register Now",
      Login: "Login",
      RequestaDemo: "Request a Demo"
    },
    bottomLinks: {
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      security: "Data Security",
      compliance: "Compliance"
    }
  },
  privacy: {
    h1: "Privacy Policy"
  }
};